export function anchorify(str) {
	return encodeURIComponent(str.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]*/g, ''))
}
